document.addEventListener("DOMContentLoaded", function () {
  var classSticky = "sticky";
  var stickyCta = document.querySelector(".sticky-cta-wrapper");

  // Ensure the sticky CTA always has the 'sticky' class
  stickyCta.classList.add(classSticky);

  // Remove the scroll event listener as it is not needed
});
